var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-book-gallery"},[_c('DuiGallery',{staticClass:"background-grey",attrs:{"images":_vm.vm.bookImages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }